import { Partner } from 'app/api/@generated/backend';

import { EcomDataLayerEventType } from 'app/data-layers/model/data-layer-event-types';
import { DataLayerEcomItem, FunnelEvent } from 'app/data-layers/model/data-layer-event';
import { DataLayerStaticData } from 'app/data-layers/static-data/data-layer-static-data';
import { DataLayerUtils } from 'app/data-layers/utils/data-layer-utils';

export const pushFunnelEventStep = (
    funnelStep: EcomDataLayerEventType,
    partner?: Partner,
    ecomItemList?: DataLayerEcomItem[],
) => {
    const funnelStepIndex = Object.values(EcomDataLayerEventType).indexOf(funnelStep) + 1;

    const funnel: FunnelEvent = {
        event: DataLayerStaticData.FUNNEL_STEP,
        funnel_step: funnelStep,
        element_category: DataLayerStaticData.ITEM_PRODUCT_TYPE,
        partner_id: partner?.id || '',
        partner_name: partner?.name || '',
        business_unit: DataLayerStaticData.BUSINESS_UNIT,
        step: funnelStepIndex,
        ...(ecomItemList
            ? {
                  item_id_list: getFunnelStepItemsList(ecomItemList, (item) => item.item_id),
                  item_category_list: getFunnelStepItemsList(ecomItemList, (item) =>
                      [item.item_category1, item.item_category2, item.item_category3]
                          .filter((category) => Boolean(category))
                          .join('/'),
                  ),
                  item_name_list: getFunnelStepItemsList(ecomItemList, (item) => item.item_name),
              }
            : []),
    };

    DataLayerUtils.pushToDataLayer(funnel);
};

const getFunnelStepItemsList = (items: DataLayerEcomItem[], mapper: (items: DataLayerEcomItem) => string) =>
    JSON.stringify(items.map((item) => ({ prod: mapper(item) })));
